import { Dispatch } from 'redux';
import { postData } from '../../../api/glAxios';
import { getMIQAmenitiesByType } from '../../../api/glQueries';

export const SET_MIQ_AMENITIES = 'SET_MIQ_AMENITIES';

export interface MIQAmenity {
    key: string;
    value: string;
}

export interface SetMiqAmenitiesAction {
    type: typeof SET_MIQ_AMENITIES;
    payload: {
        cacheKey: string;
        amenities: MIQAmenity[];
    };
}

export const setMiqAmenities = (cacheKey: string, amenities: MIQAmenity[]): SetMiqAmenitiesAction => ({
    type: SET_MIQ_AMENITIES,
    payload: { cacheKey, amenities }
});

export const loadMiqAmenities = (propertyType: string, country: string, defaultOptions: MIQAmenity[] = []) => {
    return async (dispatch: Dispatch, getState: any) => {
        if (!propertyType || !country || propertyType.trim() === '' || country.trim() === '') {
            return;
        }

        const cacheKey = `${country}_${propertyType}`;
        const state = getState();
        const cache = state.system ? state.system.miqAmenitiesCache || {} : {};

        // Return if already cached
        if (cache[cacheKey] && cache[cacheKey].length > 0) {
            return;
        }

        try {
            const response = await postData(getMIQAmenitiesByType(propertyType, country));
            let amenities = (response && response.data && Array.isArray(response.data.miqAmenities)) ? response.data.miqAmenities : [];

            // If API returns empty, use default options directly
            if (amenities.length === 0) {
                amenities = defaultOptions;
            }

            dispatch(setMiqAmenities(cacheKey, amenities));
        } catch (error) {
            // On error, use default options as fallback
            dispatch(setMiqAmenities(cacheKey, defaultOptions));
        }
    };
};

export const clearMiqAmenitiesCache = () => ({
    type: 'CLEAR_MIQ_AMENITIES_CACHE'
});
